import { PropTypes } from 'react';
import classNames from 'classnames';

const Icon = props => {
    const { icon, type, styles, onClick } = props;
    const className = classNames('cn-icon', type);
    return <svg className={className} style={styles} onClick={onClick}><use xlinkHref={`#${icon}`} /></svg>;
};

Icon.propTypes = {
    icon: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.string,
    styles: PropTypes.string
};

export default Icon;



// WEBPACK FOOTER //
// ./app/components/icon.jsx